import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getFAQItems } from '@/mocks/categories';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqItems = getFAQItems(t);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-3">
            {t('faq')}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-background-50 transition-colors"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed border-t border-background-100 pt-4">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}